import { render, staticRenderFns } from "./baseInputNumber.vue?vue&type=template&id=1838b87e&"
import script from "./baseInputNumber.vue?vue&type=script&lang=ts&"
export * from "./baseInputNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports